import classnames from 'classnames/bind';
import type { ElementType, ReactNode } from 'react';
import type { PolymorphicProps } from 'app/globalTypes';
import { LayoutJustification } from 'app/lib/constants';
import * as styles from './ModalActions.css';

const cx = classnames.bind(styles);

export interface Props {
    testId?: string;
    className?: string;
    justify?: LayoutJustification;
    children?: ReactNode;
}

export function ModalActions<As extends ElementType>(props: PolymorphicProps<As, Props>) {
    const {
        as: Component = 'div',
        testId,
        className,
        justify = LayoutJustification.END,
        children,
        ...rest
    } = props;

    const classes = cx('base', justify, className);

    return (
        <Component className={classes} data-testid={testId} {...rest}>
            {children}
        </Component>
    );
}
